import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'app/components/ui/alert-dialog';
import { toast } from 'sonner';

import { useEffect } from 'react';
import { useCourseSlice } from '../../slice';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: { tag_id: string | number };
}

export function AlertCourseTagsDelete({ isOpen, onOpenChange, data }: Props) {
  const { useDeleteCourseTagsMutation } = useCourseSlice();

  const [
    deleteTags,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteCourseTagsMutation();

  const handleDelete = () => {
    deleteTags(data?.tag_id);
  };

  useEffect(() => {
    if (deleteError) {
      toast.error(deleteError?.message || 'An error occurred');
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast.success(deletedData?.message || 'Tag deleted successfully');
      onOpenChange(false);
    }
  }, [deletedData]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
